import { useState } from 'react';
import { Popover as MuiPopover, Typography } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';
import { usePopoverStyles } from './popover.styles';
import { useTextStyles } from '../../../theme/text';
import clsx from 'clsx';

export interface PopoverProps {
  title: string;
  text: string;
}

export const Popover = ({ title, text }: PopoverProps) => {
  const classes = usePopoverStyles();
  const textClasses = useTextStyles();
  const [anchorEl, setAnchorEl] = useState(null);

  const handlePopoverOpen = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handlePopoverClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);

  return (
    <>
      <InfoOutlined
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
        style={{ marginLeft: '0.5rem' }}
      />
      <MuiPopover
        className={classes.popover}
        classes={{
          paper: classes.paper
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Typography className={clsx(classes.title, textClasses.h3)}>{title}</Typography>
        <Typography className={clsx(classes.text, textClasses.body)}>{text}</Typography>
      </MuiPopover>
    </>
  );
};
